
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import { SidebarFooter as UISidebarFooter, SidebarGroup, SidebarGroupContent } from '@/components/ui/sidebar';
import NavItem from './NavItem';
import { bottomNavItems } from './navigationItems';
import { cn } from "@/lib/utils";

const SidebarFooter = () => {
  const location = useLocation();
  
  return (
    <UISidebarFooter className={cn(
      "border-t border-sidebar-border bg-sidebar",
      "py-2 px-2 mt-auto", // Ensure it's at the bottom
      // Temporary debugging - make it more visible
      "min-h-[120px]" // Ensure minimum height for 3 buttons
    )}>
      <SidebarGroup className="py-0">
        <SidebarGroupContent>
          <ErrorBoundary 
            fallback={
              <div className="p-2 text-sidebar-foreground text-xs border border-red-300 bg-red-50">
                Erro ao carregar menu inferior
              </div>
            }
            componentName="SidebarFooterMenu"
          >
            <div className="space-y-1">
              {bottomNavItems.map((item) => {
                console.log("Rendering footer item:", item.label, item.path); // Debug log
                return (
                  <NavItem 
                    key={item.path}
                    icon={item.icon}
                    label={item.label}
                    path={item.path}
                    isActive={location.pathname === item.path}
                    external={item.external}
                  />
                );
              })}
            </div>
          </ErrorBoundary>
        </SidebarGroupContent>
      </SidebarGroup>
    </UISidebarFooter>
  );
};

export default SidebarFooter;
